<script>
const backendUrl = process.env.VUE_APP_BACKEND_URL;

export default {
    data() {
        return {
            errorMessage: ''  // Поле для сообщения об ошибке
        }
    },
    methods: {
        callback(response) {
            const access_token = response.credential;
            fetch(`${backendUrl}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ access_token }),
                credentials: 'include'
            })
            .then(response => {
                if (response.ok) {
                    this.$router.push('/')
                } else if (response.status === 401) {
                    this.errorMessage = 'Ошибка аутентификации. Пожалуйста, войдите заново.';
                } else {
                    throw new Error('Ошибка HTTP: ' + response.status);
                }
            })
            .catch(error => {
                console.error('Ошибка при обработке ответа:', error);
                this.errorMessage = 'Произошла ошибка при выполнении запроса.';
            });
        }
    },
    mounted() {
        fetch(`${backendUrl}/check_user`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        })
        .then(response => {
            if (response.ok) {
                this.$router.push('/')
            }
            else {
                throw new Error('Ошибка HTTP: ' + response.status);
            }
        })
        .catch(() => {

        });
    }
}
</script>

<template>
    <div class="auth-background">
        <div class="auth-container">
            <div class="auth-header">
                <h1>Listener</h1>
            </div>
            <div class="auth-google-container">
                <GoogleLogin class="auth-google" :callback="callback"></GoogleLogin>
            </div>
            <p v-if="errorMessage" class="error">{{ errorMessage }}</p> <!-- Вывод ошибки -->
        </div>
    </div>
</template>

<style>
.auth-google-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
}

.auth-header h1 {
    font-weight: 600;
    font-size: 23px;
    margin-top: 4px;
}

.auth-header {
    display: flex;
    justify-content: center;
    padding-top: 24px;
    gap: 9px;
}

.auth-background {
    background: #f0f3fa;
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.auth-container {
    margin-top: -40px;
    border-radius: 8px;
    background: white;
    height: 320px;
    width: 400px;
    border: 1px solid #d2b7ff;
}

.error {
    color: red;
    font-size: 0.9rem;
    margin-top: 10px;
    text-align: center;
}
</style>
